<template>
  <div :key="switch1">
    <loading-component :value="loading" />

    <div class="page-wrap">
      <div class="responsive-toolbar">
        <div class="toolbar-top">
          <div class="toolbar-title">Drivers Transfers</div>
          <div v-if="isCompanyCenter" class="gift-balance-label">
            Gift budget: <span class="gift-balance-value">{{ giftBalance | money }}</span>
          </div>
        </div>

        <div class="toolbar-controls">
          <choose-date class="control-field" label="From" v-model="fromDate"></choose-date>
          <choose-date class="control-field" label="To" v-model="toDate"></choose-date>
          <v-btn color="primary" dark class="mb-3 cbtn control-btn" @click="getAccountingData(false)"
            :loading="loading">Get Data</v-btn>
          <v-btn color="primary" dark class="mb-3 cbtn control-btn" @click="getAccountingData(true)"
            :loading="loading">Export CSV</v-btn>
          <v-btn color="primary" dark class="mb-3 cbtn control-btn" @click="payPopup()"
            :loading="loading">Transfer</v-btn>

          <v-text-field v-model="search" class="control-field control-search" append-icon="search" label="Search"
            single-line hide-details @keyup.enter="getAccountingData(false)" @click:append="getAccountingData(false)"></v-text-field>
        </div>
      </div>

      <div class="table-wrap">
        <v-data-table :headers="headers" :items="accountingData" class="elevation-1" :pagination.sync="pagination"
          :rows-per-page-items="[5, 10, 15, 25, 100]" :loading="loading" :total-items="totalItems"
          :hide-headers="$vuetify.breakpoint.xsOnly">
          <template v-slot:items="props">
            <tr v-if="!$vuetify.breakpoint.xsOnly">
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.captain_full_name }}</td>
              <td class="text-xs-left">{{ props.item.captain_username }}</td>
              <td class="text-xs-left">{{ props.item.required_to_pay | money }}</td>
              <td class="text-xs-left">{{ formatDate(props.item.created_at) }}</td>
            </tr>
            <tr v-else class="mobile-card-row">
              <td :colspan="headers.length" class="mobile-card-cell">
                <div class="payment-card">
                  <div class="card-row">
                    <span class="card-label">#</span>
                    <span class="card-value">{{ props.item.id }}</span>
                  </div>
                  <div class="card-row">
                    <span class="card-label">Driver Name</span>
                    <span class="card-value">{{ props.item.captain_full_name }}</span>
                  </div>
                  <div class="card-row">
                    <span class="card-label">Phone Number</span>
                    <span class="card-value">{{ props.item.captain_username }}</span>
                  </div>
                  <div class="card-row">
                    <span class="card-label">Amount</span>
                    <span class="card-value">{{ props.item.required_to_pay | money }}</span>
                  </div>
                  <div class="card-row">
                    <span class="card-label">Date</span>
                    <span class="card-value">{{ formatDate(props.item.created_at) }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Choose a driver </span>
        </v-card-title>
        <v-card-text>
          <v-form :key="formKey" ref="transferForm">
            <v-autocomplete :rules="[rules.required]" v-model="returnObject" clearable :items="captains"
              :loading="captainLoading" :search-input.sync="captainSearch" label="Driver" item-text="text"
              item-value="text" placeholder="Search for a driver" no-filter return-object>
              <template slot="item" slot-scope="captains">
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="captains.item.first_name + ' ' + captains.item.last_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="captains.item.username"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

            <center-gift-channel v-if="isCompanyCenter" v-model="channel" :gift-balance="giftBalance" />
            <v-text-field :rules="[rules.required, rules.number]" label="Amount" type="number" v-model="paidAmount"
              placeholder="Amount" />
          </v-form>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-btn color="primary" class="dialog-btn" :loading="captainLoading" flat @click="pay(0)">Remove Balance</v-btn>
          <v-btn color="primary" class="dialog-btn" :loading="captainLoading" flat @click="pay(1)">Add Balance</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import { companyNow, companyToday, formatCompanyTime } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import CenterGiftChannel from "@/components/CenterGiftChannel";
import centerGiftChannel from "@/mixins/centerGiftChannel";
import axios from "axios";
let CancelToken = axios.CancelToken;
let cancel;

export default {
  name: "DriversTransfers",
  title: "Drivers Transfers",
  components: {
    LoadingComponent,
    ChooseDate,
    CenterGiftChannel
  },
  mixins: [centerGiftChannel],
  data() {
    return {
      rules: {
        length: (len) => (v) =>
          (v || "").length >= len || `Invalid character length, required ${len}`,
        required: (v) => !!v || "This field is required",
        number: (v) => /^\d+(\.\d+)?$/.test(v) || "Must be a positive number"
      },
      formKey: 0,
      accountingData: [],
      loading: false,
      captainLoading: false,
      returnObject: null,
      paidAmount: 0,
      search: '',
      dialog: false,
      captains: [],
      paidAmount: 0,
      captainSearch: null,
      fromDate: companyNow().startOf("year").format("YYYY-MM-DD"),
      toDate: companyToday(),
      totalItems: 0,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Driver Name', value: 'captain_full_name' },
        { text: 'Driver Phone Number', value: 'captain_username' },
        { text: 'Amount', value: 'required_to_pay' },
        { text: 'Date', value: 'created_at' }
      ],
      pagination: {
        sortBy: "id",
        descending: true,
        rowsPerPage: 25,
        page: 1,
      },

      switch1: null,
      isInitialLoad: true,
    };
  },
  mounted() {
    this.fromDate=companyNow().startOf("year").format("YYYY-MM-DD")
    this.toDate= companyToday()
    this.getAccountingData();
    // Set flag to false after initial load to allow watcher to work
    this.$nextTick(() => {
      this.isInitialLoad = false;
    });
  },

  watch: {

    pagination: {
      handler() {
        // Prevent watcher from triggering on initial mount
        if (!this.isInitialLoad) {
          this.getAccountingData();
        }
      },
      deep: true,
    },

    captainSearch(val) {

      if (val.startsWith("0")) val = val.slice(1);
      if( val.length != 9 )
        return;
     
      this.captainLoading = true;
      if (cancel) cancel();
      const params = new URLSearchParams(this.initialSearchParams);
      params.append("search", val);
      this.axios
        .get("captain/search", {
          params: params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c; // c is the cancel function
          }),
        })
        .then((res) => {
          this.captains = [res.data.data].map((item) => ({
            text: `${item.full_name || ""}` + " " + `${item.username || ""}`,
            ...item,
          }));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.captainLoading = false));
    },

    dialog: function (val) {
      this.captainLoading = false;
      if (!val)
        this.returnObject = null;
      else
        this.formKey++;

      this.paidAmount = 0;
    },
  
  },
  methods: {
    payPopup() {
      this.dialog = true;
    },
    formatDate(date) {
      if (!date) return "";
      // Final-version doc 2026-10-05: Damascus time, whatever the PC zone.
      return formatCompanyTime(date, "DD-MM-YYYY HH:mm:ss", "");
    },
   
    getAccountingData(excel = false) {
      // Only the export button asks for a file: the search handlers used to
      // hand their DOM event in as this flag, so every search downloaded a CSV.
      excel = excel === true;

      const params = new URLSearchParams();
      const sortBy = this.pagination.sortBy || "id";
      const descending = Boolean(this.pagination.descending);

      if (!this.fromDate || !this.toDate) {
        window.getApp.$emit("SHOW_TOAST", "Please select a date range", "red");
        return;
      }
      if (this.fromDate > this.toDate) {
        window.getApp.$emit("SHOW_TOAST", "From date must be before to date", "red");
        return;
      }
      this.loading = true;
      params.append("perPage", String(this.pagination.rowsPerPage));
      params.append("page", this.pagination.page);
      params.append("sortBy", sortBy);
      params.append("descending", String(descending));
      params.append("excel", excel ? 1 : 0);
      params.append("from", this.fromDate);
      params.append("to", this.toDate);
      if (this.search) {
        params.append("search", this.search);
      }


      this.axios
        .get("accounting", { params: params, responseType: excel ? "blob" : "json" })
        .then(({ data }) => {
          if (!excel) {
            const responseData = data.data || {};
            this.accountingData = responseData.data || [];
            this.totalItems = responseData.total || 0;
            if (responseData.per_page) {
              this.pagination.rowsPerPage = Number(responseData.per_page);
            }
          } else {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Drivers_transfers.csv");
            document.body.appendChild(link);
            link.click();
          }

        })
        .catch(() => {
          this.accountingData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    pay(to) {
      const form = this.$refs.transferForm;
      if (!form.validate()) {
        return;
      }
      let paid = this.paidAmount;
      if (to == 0)
        paid = -this.paidAmount;
      this.captainLoading = true;
      this.axios
        .post(`transfer`, {
          captain_id: this.returnObject.id,
          // Operator types in new pounds; backend stores in old units -> x100.
          amount: this.toStoredAmount(paid),
          ...this.channelPayload()
        })
        .then(({ data }) => {
          this.afterTransfer(data && data.data);
          window.getApp.$emit(
            "SHOW_TOAST",
            `Transfer added successfully`,
            "green"
          );
          this.getAccountingData();

        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message || "Error Occurrd", "red");

        }).finally(() => {
          this.dialog = false;
          this.captainLoading = false;
        });
    }
  
  },
};
</script>

<style scoped>
.page-wrap {
  width: 100%;
  box-sizing: border-box;
}

.responsive-toolbar {
  background: #fff;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.toolbar-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
}

.toolbar-title {
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.toolbar-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.control-field {
  flex: 1 1 200px;
  min-width: 160px;
  max-width: 240px;
}

.control-search {
  flex: 0 1 280px;
  max-width: 280px;
  margin-left: auto !important;
}

.control-btn {
  flex: 0 0 auto;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-card-cell {
  padding: 12px !important;
  height: auto !important;
}

.mobile-card-row td {
  border-bottom: 8px solid #f5f5f5 !important;
}

.payment-card {
  width: 100%;
  background: #fff;
  border-radius: 6px;
  padding: 4px 8px;
}

.dialog-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dialog-btn {
  flex: 1 1 45%;
  min-width: 0;
  margin: 0 !important;
}

@media (max-width: 600px) {
  .responsive-toolbar {
    padding: 10px 12px;
  }
  .toolbar-title {
    font-size: 18px;
  }
  .control-field,
  .control-search {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    margin-left: 0 !important;
  }
  .control-btn {
    flex: 1 1 100%;
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .dialog-btn {
    flex: 1 1 100%;
  }
}

.filters-container {
  padding: 16px;
}

.cards-container {
  padding: 16px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.card-row:last-child {
  border-bottom: none;
}

.card-label {
  font-weight: 600;
  color: #666;
  font-size: 14px;
}

.card-value {
  color: #333;
  font-size: 14px;
  text-align: right;
}

.card-value.balance {
  font-weight: 700;
  font-size: 16px;
}

.card-value.balance.positive {
  color: #4caf50;
}

.card-value.balance.negative {
  color: #f44336;
}

.card-actions {
  padding: 8px 16px;
  justify-content: flex-end;
}

.pagination-container {
  padding: 16px;
  display: flex;
  justify-content: center;
}

.date-filter {
  max-width: 170px;
  margin-right: 12px;
}
/* Accountant doc 2026-10-03 item 1.9: the company center's gift budget. */
.gift-balance-label {
  font-size: 14px;
  color: #546e7a;
}

.gift-balance-value {
  font-weight: 600;
  color: #333;
}
</style>
